import { useState, useCallback } from "react";
import clsx from "clsx";
import type { FieldError, UseFormRegisterReturn } from "react-hook-form";
import ErrorMessage from "@/components/ui/form/ErrorMessage";

interface LabelInputProps {
  id?: string;
  label?: string;
  type?: "text" | "email" | "number";
  registerProps: UseFormRegisterReturn;
  value?: any;
  error?: FieldError;
  classes?: string;
  placeholder?: string;
}

const LabelInput = ({
  id,
  label = "",
  type = "text",
  registerProps,
  value = "",
  error,
  classes = "",
}: LabelInputProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = !!value;

  const handleFocus = useCallback(() => setIsFocused(true), []);
  const handleBlur = useCallback(() => setIsFocused(false), []);

  return (
    <div className={clsx("flex-1", classes)}>
      <div className="relative flex flex-col">
        <label
          htmlFor={id}
          className={clsx(
            "pointer-events-none absolute left-4 font-normal text-neutral transition-all",
            {
              "text-md top-1/2 -translate-y-1/2": !hasValue && !isFocused,
              "left-3 top-1 -translate-y-0 scale-90 text-xs": hasValue || isFocused,
            },
          )}
        >
          {label}
        </label>
        <input
          id={id}
          type={type}
          {...registerProps}
          defaultValue={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          aria-invalid={!!error}
          className={clsx("brand-input-base input-neutral input input-bordered focus:input-info", {
            "pt-0": !hasValue && !isFocused,
            "pt-3": hasValue || isFocused,
            "input-error !outline-error": error,
          })}
        />
      </div>
      <ErrorMessage message={error?.message} />
    </div>
  );
};

export default LabelInput;
